import React, {Fragment} from 'react'

import {
  EuiBreadcrumbs,
  EuiSpacer
} from '@elastic/eui'


export default function ManualBreadcrumbs() {

  const breadcrumbs = [
    {
      text: 'Über',
      href: '/de/Software/Windows/InstarVision/About/'
    },
    {
      text: 'Erweitert',
      href: '/de/Software/Windows/InstarVision/Advanced/',
    },
    {
      text: 'Kameraliste',
      href: '/de/Software/Windows/InstarVision/Camera_List/'
    },
    {
      text: 'Bildeinstellungen',
      href: '/de/Software/Windows/InstarVision/Image_Adjust/'
    },
    {
      text: 'Layout',
      href: '/de/Software/Windows/InstarVision/Layout/'
    },
    {
      text: 'PTZ',
      href: '/de/Software/Windows/InstarVision/PTZ/'
    },
    {
      text: 'System',
      href: '/de/Software/Windows/InstarVision/System/'
    },
    {
      text: 'Benutzer',
      href: '/de/Software/Windows/InstarVision/Users/'
    },
    {
      text: '◄ InstarVision',
      href: '/de/Software/Windows/InstarVision/',
    }
  ];

  return (
    <Fragment>
      <EuiBreadcrumbs
        truncate={true}
        breadcrumbs={breadcrumbs}
        max={11}
        aria-label="Software Platform for your INSTAR IP Camera"
      />
      <EuiSpacer />
    </Fragment>
  );
}
